import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "children", "disabled", "isActive", "isLoading", "color"];
import { Button as MaterialButton, CircularProgress } from '@material-ui/core';
import { forwardRef } from 'react';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var Button = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      size,
      children,
      disabled,
      isActive,
      isLoading,
      color = 'primary'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(MaterialButton, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    size: size,
    "data-color": color,
    "aria-busy": isLoading,
    "aria-expanded": isActive,
    disabled: disabled || isLoading,
    color: color === 'primary' ? color : 'default',
    children: !isLoading ? children : /*#__PURE__*/_jsxs(_Fragment, {
      children: [children, /*#__PURE__*/_jsx(CircularProgress, {
        size: "1em",
        color: "inherit"
      })]
    })
  }));
});
if (process.env.NODE_ENV !== "production") Button.displayName = "Button";